import axios from 'axios';
import API_BASE_URLS from './apiConfig';

export const SESSION_EXPIRED_KEY = 'sessionExpiredMessage';
export const SESSION_EXPIRED_MESSAGE = 'Your session has expired. Please log in again.';

// A 401 on a request that carried our token means the session is genuinely over.
// Other failures (404, 500, network) are left to the calling page and never log the user out.
const endSession = () => {
  if (window.location.pathname === '/login') return;
  const keep = localStorage.getItem('mobileNumber');
  localStorage.clear();
  if (keep) localStorage.setItem('mobileNumber', keep);
  try {
    sessionStorage.setItem(SESSION_EXPIRED_KEY, SESSION_EXPIRED_MESSAGE);
    sessionStorage.setItem('postLoginRedirect', `${window.location.pathname}${window.location.search}`);
  } catch {
    // sessionStorage unavailable: the user still lands on the login page
  }
  window.location.assign('/login');
};

export const getApiClient = (service) => {
  const instance = axios.create({
    baseURL: API_BASE_URLS[service],
    headers: {
      'Content-Type': 'application/json',
      'Accept': '*/*',
    }
  });

  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      const userId = localStorage.getItem('userId');
      if (userId) {
        config.headers['userId'] = userId;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const hadToken = !!error.config?.headers?.Authorization;
      if (error.response?.status === 401 && hadToken) endSession();
      return Promise.reject(error);
    }
  );

  return instance;
};
